import { render, staticRenderFns } from "./BankUndepositedFundSideMenu.vue?vue&type=template&id=1f15cc37"
import script from "./BankUndepositedFundSideMenu.vue?vue&type=script&lang=js"
export * from "./BankUndepositedFundSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f15cc37')) {
      api.createRecord('1f15cc37', component.options)
    } else {
      api.reload('1f15cc37', component.options)
    }
    module.hot.accept("./BankUndepositedFundSideMenu.vue?vue&type=template&id=1f15cc37", function () {
      api.rerender('1f15cc37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bankundepositedfund/BankUndepositedFundSideMenu.vue"
export default component.exports